import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {deleteCandidate} from '/redux/action/candidate.action';
import {
  acceptBeforeById,
  clientDetailsById,
  createdTsById,
  emailById,
  flagById,
  nameById,
  sourceById,
  statusById,
} from '/redux/selector/candidate.selector';
import {allReportData} from '/redux/selector/report.selector';

import MergeBanner from './MergeBanner';

export default connect(
  createStructuredSelector({
    name: nameById,
    email: emailById,
    source: sourceById,
    createdOn: createdTsById,
    flag: flagById,
    clientDetails: clientDetailsById,
    allReportData,
    acceptBefore: acceptBeforeById,
    status: statusById,
  }),
  dispatch => ({
    deleteCandidate: ({candidateId, allReportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(deleteCandidate({candidateId, allReportData})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    deleteCandidate: ({}) => {
      const {candidateId} = ownProps;
      const {allReportData} = stateProps;
      return dispatchProps.deleteCandidate({
        candidateId,
        allReportData,
      });
    },
  }),
)(MergeBanner);
